import { MutableRefObject } from 'react';

/**
 * Capture the element that currently holds focus into a ref, so focus can be restored to it later —
 * typically paired with `useRestoreFocusOnClose`: call this when opening a dialog to remember the
 * trigger, then restore focus to it on close.
 *
 * Focus on `<body>` (or a non-element) is ignored so a previously captured trigger is never
 * overwritten with a meaningless value.
 *
 * @param triggerRef Ref to populate with the currently focused element.
 */
export function captureFocusedTrigger<T extends HTMLElement>(triggerRef: MutableRefObject<T | null>): void {
    const { activeElement } = document;
    if (activeElement instanceof HTMLElement && activeElement !== document.body) {
        // Mutating the passed ref is the whole point of this helper.
        // eslint-disable-next-line no-param-reassign
        triggerRef.current = activeElement as T;
    }
}
